import styled from 'styled-components';

export const StyledPasswordValidation = styled.div`
    width: 273px;
    height: 280px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    margin: 0 0 0 4px;
    padding: 19px 16px 24px 16px;

  .pwMustContain {
    width: 221px;
    height: 24px;
    line-height: 1.25;
  }

  .validationItem {
    width: 215px;
    height: 24px;
    line-height: 1.29;
    padding-left: 28px;
  }

  .valid {
    color: var(--cl-background-success);
    font-weight: bold;
    margin-left:-15px;
  }

  .valid:before {
    position: relative;
    content: '✓'; 
    font-weight: normal;
    left: -13px;
  }
  
  .invalid:before {
    position: relative;
  }

  .mustBeDiff {
    width: 193px;
    height: 32px;
    line-height: 1.29;
  }
`;

export default {
  StyledPasswordValidation,
};
